export class StatisticNumerical {
    public titleTranslationKey : string; // 'test.score'
    public titleText : string; // 'Total: Jim Jones'
    public number : number; // '46'
    public units? : string; // '%' or 'attempts' or 'days'
    public descriptionTranslationKey? : string; // 'test.score_description'
    public descriptionText? : string; // 'The total score for all tests'
}